import { render, staticRenderFns } from "./UserSettingsModal.vue?vue&type=template&id=76d0473d&scoped=true&"
import script from "./UserSettingsModal.vue?vue&type=script&lang=js&"
export * from "./UserSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d0473d",
  null
  
)

export default component.exports